require('../fhApp/currentUser/currentUser');
require('./subscriptionsListService');
require('./transactionsListService');
require('./../shared/dobSelectorService');

"use strict";

angular.module('app.accountSettings.accountSettingsController', [
  'app.currentUser',
  'app.accountSettings.subscriptionsListService',
  'app.accountSettings.transactionsListService',
  'app.shared.dobSelectorService'
])
  .controller('app.accountSettings.accountSettingsController', [
    '$scope',
    '$timeout',
    'currentUser',
    'app.accountSettings.subscriptionsListService',
    'app.accountSettings.transactionsListService',
    'app.shared.dobSelectorService',
    '$state',
    '$stateParams',
    'PRODUCT',
    function ($scope, $timeout, currentUser, subscriptionList, transactionsList, dobSelectorService, $state, $stateParams, PRODUCT) {
      $scope.currentUser = currentUser;
      $scope.subscriptionList = subscriptionList;
      $scope.transactionsList = transactionsList;

      $scope.hasSubscription = false;
      $scope.accountError = null;

      $scope.edit = {
        name: false,
        username: false,
        email: false,
        password: false,
        strgender: false,
        phone_number: false,
        mob: false,
      };

      $scope.product = PRODUCT;

      $scope.beginEdit = function (field) {
        switch (field) {
          case 'name':
            $scope.edit.name = [
              {
                field: 'first_name',
                value: currentUser.data.first_name
              },
              {
                field: 'last_name',
                value: currentUser.data.last_name
              }
            ];
            break;
          case 'password':
            $scope.edit.password = true;
            currentUser.reset_password(currentUser.data.login_name);
            $timeout(function () {
              $scope.edit.password = false;
            }, 3000);
            break;
          case 'mob':
            $scope.edit[field] = [{
                field: field,
                date: dobSelectorService.new(),
            }];

            if(currentUser.data.mob) {
              $scope.edit[field][0].date.month = currentUser.data.mob.getMonth() + 1;
              $scope.edit[field][0].date.day = currentUser.data.mob.getDate();
              $scope.edit[field][0].date.year = currentUser.data.mob.getFullYear();
            }
            break;
          default:
            $scope.edit[field] = [
              {
                field: field,
                value: currentUser.data[field]
              }
            ];
            break;
        }
      };

      $scope.save = function (field) {
        let data = {};
        for (let i = 0; i < $scope.edit[field].length; i++) {
          let item = $scope.edit[field][i];

          if(item.field === 'mob') {
            data[item.field] = item.date.getDate().format('YYYY-MM');
          } else {
            data[item.field] = item.value;
          }
        }
        currentUser.save(data)
          .then(
            function (response) {
              let data = response.data;

              if (data.error) {
                $scope.accountError = data.error;
              }
            }
          );

        $scope.edit[field] = false;
      };

      $scope.cancel = function (field) {
        $scope.edit[field] = false;
      };

      subscriptionList.retrieve();
      transactionsList.retrieve();

      $scope.$watch(() => {
        return currentUser.data.has_all_acc_info
      }, () => {
        if(currentUser.data.has_all_acc_info && typeof $stateParams.redirect_url === 'string' && PRODUCT.Code === 'htv') {
          let params = null;

          if ($stateParams.redirect_params) {
            params = $stateParams.redirect_params;
          }

          $timeout(function () {
            $state.go($stateParams.redirect_url, params);
          }, 500);
        }
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/accountSettings/accountSettingsController.js